export const filterObjectivesByTags = ({
    filterTagsId,
    filterTagsType,
    objectives,
}) => {
    if (filterTagsId.length === 0) return objectives;
    const filtered = objectives.filter((obj) => {
        if (!obj.Etiquetas) return false;
        let tieneEtiquetas = true;

        if (filterTagsType === "AND") {
            for (const id of filterTagsId) {
                if (!obj.Etiquetas.find((et) => et.etiqueta_id === id)) {
                    tieneEtiquetas = false;
                    break;
                }
            }
        } else {
            tieneEtiquetas = obj.Etiquetas.filter((et) =>
                filterTagsId.includes(et.etiqueta_id)
            ).length;
        }
        return tieneEtiquetas;
    });

    return filtered;
};
